import { Button, Col, Row } from "reactstrap";
import { Documentation } from "../../Constants/Constants";
import { dynamicImage, Image } from "../../Utils";
import SvgIcon from "../CommonComponents/SvgIcon";
import Tilt from "react-parallax-tilt";

const SliderSection = () => {
  return (
    <div className="custom-container section-py-space">
      <Row className="align-items-center">
        <Col xl="5" lg="6" xs="12">
          <div className="home-content">
            <h2>{"Easy to use our"} <span>{"chat app"} </span>{"attractive and clean design"}</h2>
            <p>{"Desktop App - Easy to use chat app, attractive and clean design, with many features dark & light, recent chat and many more..."}</p>
            <div>
              <Button tag={"a"} className="button-doc" href="https://docs.pixelstrap.net/react/chatzy/document" target="_blank">
                <SvgIcon iconId="landing-doc" />{Documentation}
              </Button>
              <div className="downlaod">
                <div>
                  <div className="footer-contant1">
                    <div className="footer-btn">
                      <Button tag={"a"} active color="transparent"><i className="fa fa-apple" /></Button>
                      <Button tag={"a"} color="transparent"><i className="fa fa-play" /></Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col xl="7" lg="6" className="home-img">
          <Tilt>
            <Image className="img-fluid js-tilt" src={dynamicImage("index/home/home-main.png")} alt="Slider" />
          </Tilt>
          <Image className="img-fluid" src={dynamicImage("index/home/1.png")} alt="Slider" />
          <Image className="img-fluid" src={dynamicImage("index/home/2.png")} alt="Slider" />
        </Col>
      </Row>
    </div>
  );
};

export default SliderSection;
